import React from 'react';
import './BrandLockup.css';

export default function BrandLockup({
  containerClassName = '',
  logoClassName = '',
  imageClassName = '',
  textWrapperClassName = '',
  titleClassName = '',
  subtitleClassName = '',
  title = 'Global Mobility',
  subtitle = 'Spain Regularization 2026',
  showSubtitle = true,
}) {
  return (
    <div className={containerClassName}>
      <div className={`gm-brand-logo ${logoClassName}`}>
        <img src="/header-logo.png" alt="Global Mobility logo" className={`gm-brand-logo-image ${imageClassName}`} />
      </div>
      <div className={textWrapperClassName}>
        <div className={titleClassName}>{title}</div>
        {showSubtitle ? <div className={subtitleClassName}>{subtitle}</div> : null}
      </div>
    </div>
  );
}
